import { put, select } from 'redux-saga/effects'
import { getDiagnosisOptionsSelector } from '../../options/selectors/getDiagnosisOptions.selector'
import { IDiagnosisOptionsState, IPtCategoryOption } from '../../options/store/options.types'
import { IPcr } from '../../pcr/store/pcr.types'
import { IDiagnosisOption, IDiagnosisState } from '../../diagnosis/store/diagnosis.types'
import { initialDiagnosisState } from '../../diagnosis/store/diagnosis.reducers'
import { getDiagnosisSelector } from '../../diagnosis/selectors'
import { setImpressions, setOrganSystems } from '../../diagnosis/store/diagnosis.actions'
import { DiagnosisConstants } from '../../diagnosis/store/diagnosis.constants'

export function* setDiagnosisDefaults(patientCategory: IPtCategoryOption, pcr: IPcr) {
  const { organSystems, impressions }: IDiagnosisState = yield select(getDiagnosisSelector)
  const { systemOptions, impressionsOptions }: IDiagnosisOptionsState = yield select(getDiagnosisOptionsSelector)
  const { organSystemIds, impressionIds } = patientCategory
  if ((!organSystems || organSystems?.length === 0) && organSystemIds) {
    const systemIdsList = organSystemIds?.split(',')
    const organSystemsDefaults: IDiagnosisOption[] = []
    systemIdsList.forEach((id, index) => {
      const segmentId = index === 0 ? +DiagnosisConstants.PRIMARY_SEGMENT_ID : +DiagnosisConstants.OTHER_SEGMENT_ID
      const option = systemOptions.find((o) => o.id === +id)
      if (option) organSystemsDefaults.push({ ...option, segmentId })
    })
    if (organSystemsDefaults.length > 0) {
      yield put(setOrganSystems(organSystemsDefaults))
      if (pcr.diagnosis) pcr.diagnosis.organSystems = organSystemsDefaults
      else pcr.diagnosis = { ...initialDiagnosisState, organSystems: organSystemsDefaults }
    }
  }
  if ((!impressions || impressions?.length === 0) && impressionIds) {
    const impressionIdsList = impressionIds?.split(',')
    const impressionDefaults: IDiagnosisOption[] = []
    impressionIdsList.forEach((id, index) => {
      let segmentId = -1
      if (index === 0) segmentId = DiagnosisConstants.PRIMARY_SEGMENT_ID
      else if (index === 1) segmentId = DiagnosisConstants.SECONDARY_SEGMENT_ID
      else if (index > 1) segmentId = DiagnosisConstants.OTHER_SEGMENT_ID
      const option = impressionsOptions.find((o) => o.id === +id)
      if (option) impressionDefaults.push({ ...option, segmentId })
    })
    if (impressionDefaults.length > 0) {
      yield put(setImpressions(impressionDefaults))
      if (pcr.diagnosis) pcr.diagnosis.impressions = impressionDefaults
      else pcr.diagnosis = { ...initialDiagnosisState, impressions: impressionDefaults }
    }
  }
}
